




































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Decimal from '@/utils/decimal';

@Component({})
export default class Diff extends Vue {
  @Prop({ required: true }) private year!: number;
  @Prop({ required: true }) private data!: object;

  private translate(key: string, options = {}) {
    return this.$t(`PaycheckReport.AmeldingAndBookkeepingReconciliation.Diff.${key}`, options);
  }

  // see at a glance if there are any significant errors in the most important cells
  private warnDiffFromZero(amount: Decimal) {
    if (amount.greaterThan(20) || amount.lessThan(-20)) {
      return 'warn major';
    } else if (amount.greaterThan(5) || amount.lessThan(-5)) {
      return 'warn minor';
    } else {
      return '';
    }
  }
}
